import baustein from "baustein";
import { openShippingAndReturnsOverlay } from "web/redux/ducks/shipping-and-returns-overlay";
import store from "web/redux/store";

export const SHIPPING_AND_RETURNS_LINK_SELECTOR = ".buybuybuy-option__shipping-and-returns-link";
const BUY_BUTTON_SELECTOR = ".buybuybuy-option__buy-button";

/**
 * NEW BUY OPTION IN NEW PDP
 *
 * This is part of a new iteration of our PDP that's behind the `buybuybuy` Heimdall.
 * Being a test, is not all the refined it could be.
 *
 * @see components/buybuybuy-area
 * @see components/buybuybuy-options
 */
export default baustein.register("buybuybuy-option", {
    defaultOptions: {
        linkId: null,
        rawSize: null,
        price: null,
        discount: null,
        retailerSlug: null,
        onFinalSale: null,
        hasFreeShipping: null,
    },

    setupEvents(add) {
        add("click", SHIPPING_AND_RETURNS_LINK_SELECTOR, this._onShippingInfoClick);
        add("click", BUY_BUTTON_SELECTOR, this._onBuyAction);
    },

    _onShippingInfoClick(event) {
        event.preventDefault();
        const linkId = this.options.linkId;
        store.dispatch(openShippingAndReturnsOverlay(linkId));
    },

    _onBuyAction(event, target) {
        this.emit("buyOptionAddToBag", { options: this.options, target: target });
    },
});
